// src/hooks/useContactForm.ts

import { useState } from 'react';
import { submitContactForm } from '../api/contactFormService'; // Ajusta la ruta a tu servicio
import { ContactFormCreate } from '../types/interfaces';

export default function useContactForm() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const sendContactForm = async (formData: ContactFormCreate) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      await submitContactForm(formData);
      setSuccess(true);
    } catch (err: any) {
      setError(err?.message || 'Error submitting contact form');
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    success,
    sendContactForm,
  };
}
